import styled from 'styled-components'

export const ModalAlert = styled.div`
  .modal-alert {
    margin-top: 15px;
    font-size: 16px;
    text-align: center;
    line-height: 1.5;
    color: ${({ theme }) => theme.cor41}!important;
  }

  .mantine-Group-root {
    justify-content: center !important;
  }
`

export const Container = styled.div`
  display: grid;
  gap: 16px;
  max-height: 530px;
  margin-top: 16px;

  td {
    font-family: RobotoRegular !important;
    font-size: 16px !important;
    line-height: 1.5em !important;
    color: ${({ theme }) => theme.cor9}!important;
  }

  .label-quantity {
    display: flex;
    justify-content: flex-end;
    color: ${({ theme }) => theme.cor41}!important;
  }
`

export const Card = styled.div`
  background-color: ${({ theme }) => theme.cor40}!important;
  padding: 16px;
  border-radius: 8px;
  display: grid;
  gap: 5px;

  .tabela {
    width: 100% !important;
  }
`

export const ContainerTable = styled.div`
  overflow-y: auto;
  max-height: 300px;
`

export const ContainerPagination = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
`

export const PaginationDescription = styled.div`
  margin-top: 0.2em;
  font-size: 0.875em !important;
  color: ${({ theme }) => theme.cor9} !important;
`

export const MensagemAlerta = styled.div`
  font-size: 16px ;
  font-family: RobotoRegular ;
  color: ${({ theme }) => theme.cor9} ;
`

export const MensagemBold = styled.span`
  font-size: 16px ;
  font-family: RobotoBold ;
  color: ${({ theme }) => theme.cor9} ;
`


